import "./career.css";
import imgBanner from "../assest/about_us.jpg";

function Career() {
  return (
    <div className="career-page">
      {/* ===================== BANNER ===================== */}
      <div className="about-banner">
        <img src={imgBanner} alt="banner" className="banner-img" />
        <div className="banner-text">
          <h1>Career Opportunities</h1>
        </div>
      </div>
      <div className="body-container">
        <div className="bg-blobs"></div>
        <div className="bg-blobs2"></div>
        <div className="floating-dots"></div>
        {/* Work With Top Leading Company */}
        <section className="team-section mt-5">
          <h2 className="section-heading text-center mb-5">
            <span className="line"></span> Work With Top Leading Company <span className="line"></span>
          </h2>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <p className="career-text">
                  At Click Informatics, we are always on the lookout for talented and passionate individuals to join our team.
                  We believe in fostering a collaborative and inclusive work environment where creativity and innovation thrive.
                </p>

                <ul className="career-list">
                  <li>Software Developers</li>
                  <li>Data Analysts</li>
                  <li>Marketing Specialists</li>
                  <li>Customer Support Representatives</li>
                  <li>Project Managers</li>
                </ul>

                <p className="career-text">
                  To apply for any of the above positions, please send your resume and cover letter to{" "}
                  <a href="mailto:careers@clickinformatics.com">careers@clickinformatics.com</a>.
                  We look forward to hearing from you!
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Build Your Future With Us */}
        <section className="build-future-with-us mt-5">
          <h2 className="section-heading text-center mb-5">
            <span className="line"></span> Build Your Future With Us <span className="line"></span>
          </h2>

          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <p className="career-text">
                  At Click Informatics, we believe that our employees are our greatest asset.
                  We are committed to providing a supportive and inclusive work environment 
                  where our team members can thrive and grow.
                </p>
              </div>
            </div>

            <div className="career-cta text-center mt-3">
              <p>
                Every project starts with a team of dedicated employees.  
                We are looking for individuals who want to grow and build innovative web applications.
              </p>
            </div>
          </div>
        </section>

        {/* A Great Place to Work */}
        <section className="great-place-to-work text-center mt-5">
          <h2 className="section-heading mb-4">
            <span className="line"></span> A Great Place to Work <span className="line"></span>
          </h2>
          <div className="container">
            <p className="career-text mb-4">
              At Click Informatics, we look for lateral thinkers who can add value to our business and processes; have an excellent teamwork ethic, and are driven to take our organization and their own careers to new heights.
            </p>

            <p className="career-text mb-4">
              Click Informatics company is recognized for career growth opportunities and a challenging and supportive work environment that promotes personal and professional growth. Whether you are new to the workforce, or an expert in your field. Click Informatics company has exciting opportunities waiting for you!
            </p>
          </div>
        </section>

        <section className="great-place-to-work text-center mt-5">
          <h2 className="section-heading mb-4">
            <span className="line"></span>We welcomes all aspirants to join 'Our Team'.<span className="line"></span>
          </h2>
          <div className="container">
            <div className="row justify-content-center g-4">
              <div className="card m-3">
                <div className="card-body">
                  <h5 className="card-title">Sales Executive</h5>
                  <p className="card-text">'Click Informatics' is looking for a dedicated, motivated and tech savvy sales executive to handle our product and service sales. We receive many inbound inquiries per week from Google. With our expanding business, we are looking to bring on an ambitious, motivated and dedicated Sales Executives who are confident in selling template based websites and and digital marketing solutions to small, mid and large size companies.</p>
                  <a href="mailto:careers@clickinformatics.com" className="btn btn-primary">Apply Now</a>
                </div>
              </div>

              <div className="card m-3">
                <div className="card-body">
                  <h5 className="card-title">Web Designer</h5>
                  <p className="card-text">At 'Click Informatics', we design responsive websites based on HTML5, CSS3 & jQuery. We are currently looking for passionate & dedicated front-end develop who have thorough knowledge of HTML, CSS, Bootstrap, jQuery etc. Make sure you have complete knowledge about HTML5, CSS3, Bootstrap before applying for this position. You should be aware about the latest design trends and how to tackle them in HTML & CSS.</p>
                  <a href="mailto:careers@clickinformatics.com" className="btn btn-primary">Apply Now</a>
                </div>
              </div>

              <div className="card m-3">
                <div className="card-body">
                  <h5 className="card-title">Web Developer</h5>
                  <p className="card-text">At 'Click Informatics', we develop responsive websites based on PHP. We are currently looking for passionate & dedicated front-end develop who have thorough knowledge of HTML, CSS, Bootstrap, jQuery etc. We need only expert developers. You should be aware about the latest design trends and how to tackle them in HTML & CSS. Knowledge of any Project Management Tool would be an added advantage.</p>
                  <a href="mailto:careers@clickinformatics.com" className="btn btn-primary">Apply Now</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Career;
